'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './cast-vote.routes';

export class CastVoteComponent {

  constructor($state, dialogs, $uibModal, Auth, $stateParams, BallotsService, VotingsService, $window, $location, User,
              PropertyService, SettingsService, prompt) {
    'ngInject';

    this.$state = $state;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.Auth = Auth;
    this.User = User;
    this.prompt = prompt;
    this.BallotsService = BallotsService;
    this.VotingsService = VotingsService;
    this.PropertyService = PropertyService;
    this.$location = $location;
    this.$stateParams = $stateParams;

    this.back = _=> $window.history.back();

    this.voteId = $stateParams.voteId;
    this.ballotId = $stateParams.id;

    this.selection = [];
    this.writeInSelection = [];

    this.mode = this.mode || 'default';
    this.properties = $stateParams.properties;
    this.proxyName = $stateParams.proxyName;

    if (this.mode !== 'default' && !this.properties) {
      //there must be a page reload, as the properties are not provided in the url and thus are not available after a page reload
      $window.history.back();
    } else {

      SettingsService.getByName({name: 'client'}, settings => {
        this.useSuite = settings.data.useSuite;

        if (this.mode != 'default')
          this.totalProperties = this.properties.length;

        this.refreshData();
      });
    }
  }

  addWriteIn() {
    this.prompt({
      title: 'Add Response',
      message: 'Please enter your response below:',
      input: true,
      label: '',
      value: ''
    }).then(writeInResponse => {
      if (!writeInResponse || !writeInResponse.trim()) {
        alert('Your response must not be empty.');
        return;
      }

      let available = [].concat(this.ballot.responses.map(r => r.toLowerCase()), this.writeInSelection.map(r => r.toLowerCase()));
      if (available.indexOf(writeInResponse.trim().toLowerCase()) !== -1) {
        alert('There is already such a response available.');
        return;
      }

      this.writeInSelection.push(writeInResponse.trim());
      this.validateBallot();
    });
  }

  editWriteIn(idx) {
    this.prompt({
      title: 'Edit Response',
      message: 'Please edit your response below:',
      input: true,
      label: '',
      value: this.writeInSelection[idx]
    }).then(writeInResponse => {
      if (!writeInResponse || !writeInResponse.trim()) {
        alert('Your response must not be empty.');
        return;
      }

      let available = [].concat(this.ballot.responses.map(r => r.toLowerCase()), this.writeInSelection.map(r => r.toLowerCase()));
      if (available.indexOf(writeInResponse.trim().toLowerCase()) !== -1) {
        alert('There is already such a response available.');
        return;
      }

      this.writeInSelection[idx] = writeInResponse.trim();
    });

    // do it always, as we ddn't want it to be unchecked at all
    $("input.write-in").eq(idx).prop('checked', true);
  }

  removeWriteIn(idx) {
    this.writeInSelection.splice(idx,1);
    this.validateBallot();
  }

  refreshData() {
    this.availablePropertiesToVoteFor = 0;
    this.selectedProperty = undefined;
    this.Auth.isAdmin(isAdmin => {
      this.isAdmin = isAdmin;

     this.Auth.getCurrentUser(user => {
      this.user = user;
      this.userId = user._id;

      if (this.mode == 'default') {

        if (this.isAdmin) {
          this.properties = [{
            "_id": "0001",
            "lotNo": "100",
            "address": {
              "street": "100 Test Street"
            }
          }, {
            "_id": "0002",
            "lotNo": "200",
            "address": {
              "street": "200 Test Street"
            }
          }];
          this.selectedProperty = this.properties[0];
          if (this.ballotId) {
            this.BallotsService.get({id: this.ballotId}, ballot => {
              this.ballot = ballot;
              this.validateBallot(true);

              if (this.mode != 'default')
                this.rulesViolation = false;
            });
          }
          return;
        }

        let PROPERTIES_METHOD = (this.useSuite)
          ? this.User.querySuitePropertiesByUser
          : this.PropertyService.getPropertiesVotingByUser;

        PROPERTIES_METHOD({contactId: this.userId}, data => {

          if (data && data[0]) {
            this.VotingsService.get({id: this.voteId}, voting => {

              this.properties = data.filter(d => d.json)
                .map(d => JSON.parse(d.json))
                .map(d => d.property)
                .filter(d => voting.voterGroup.properties.includes(d._id)) // filter by voter group properties only
                .filter(d => d.eVoting && !d.eVoting.blocked);

              this.ownPropertyIds = this.properties.map(ppty => ppty._id);

              this.defaultProxy = (voting.defaultProxy && voting.defaultProxy.enabled) ? voting.defaultProxy.name : "";

              let myBallotVotes = voting.votes.filter(v => v.ballot == this.ballotId && this.ownPropertyIds.includes(v.property));

              myBallotVotes.forEach(vote => {
                let ppty = this.properties.find(p => p._id == vote.property);
                if (ppty)
                  ppty.alreadyVotedFor = true;
              });

              let myProxies = voting.proxies.filter(p => this.ownPropertyIds.includes(p.property) && p.proxy.enabled);

              myProxies.forEach(proxy => {
                let ppty = this.properties.find(p => p._id == proxy.property);
                if (ppty) {
                  ppty.proxyVote = true;
                  ppty.proxy = proxy.proxy;
                }
              });

              if (this.properties.length) {
                for (let ppty of this.properties) {
                  if (!ppty.alreadyVotedFor && !ppty.proxyVote) {
                    this.availablePropertiesToVoteFor++;
                  }

                  if (!ppty.alreadyVotedFor && !ppty.proxyVote && !this.selectedProperty) {
                    this.selectedProperty = ppty;
                  }
                }
              }

            });
          }

        }, err => {
          console.log("Could not retrieve users.")
        });
      } else {
        if (this.properties.length) {
          for (let ppty of this.properties) {
            this.availablePropertiesToVoteFor++;

            if (!this.selectedProperty) {
              this.selectedProperty = ppty;
            }
          }
        }
      }

      if (this.ballotId) {
        this.BallotsService.get({id: this.ballotId}, ballot => {
          this.ballot = ballot;
          this.validateBallot(true);

          if (this.mode != 'default')
            this.rulesViolation = false;
        });
      }

    });
    });
  }

  validateBallot(silent) {

    let total = this.selection.length + this.writeInSelection.length;

    if (total > this.ballot.rules.maxResponses) {
      this.rulesViolation = true;
      if (silent) return;
      this.violation = "Maximum " + this.ballot.rules.maxResponses + " response(s) allowed";
    } else if (total < this.ballot.rules.minResponses) {
      this.rulesViolation = true;
      if (silent) return;
      this.violation = "Minimum " + this.ballot.rules.minResponses + " response(s) allowed";
    } else {
      this.rulesViolation = false;
      this.violation = "";
    }
  }

  toggleSelection(response) {
    let idx = this.selection.indexOf(response);

    // Is currently selected
    if (idx > -1) {
      this.selection.splice(idx, 1);
    }

    // Is newly selected
    else {
      this.selection.push(response);
    }

    this.validateBallot();

    if (this.mode != 'default')
      this.rulesViolation = false;
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {

      composedName = contact.firstName;


      if (contact.middleName)
        composedName += " " + contact.middleName;

      composedName += " " + contact.lastName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  castVote() {

    let onSuccess = _ => {
      this.secureStoring = false;

      if (this.availablePropertiesToVoteFor === 1) {
        let dlg = (this.properties.length === 1)
          ? this.dialogs.notify("Success", "Your vote has been cast successfully")
          : this.dialogs.notify("Success", "All your votes have been cast successfully");

        dlg.result.then(() => {
          if (this.isAdmin && this.mode !== 'default') {
            this.$location.url("/voting/" + this.voteId);
          } else {
            this.$location.url("/home");
          }
        });
      } else {
        let number = this.availablePropertiesToVoteFor -1;
        let strNumber = (number == 1) ? `is <b>one more property</b>` : `are <b>${number} more properties</b>`;
        let dlg = this.dialogs.notify("Success", `Your vote has been cast successfully.<br/>There ${strNumber} you can cast your vote for.`);

        dlg.result.then(() => {
          this.refreshData();
        });
      }

    };

    if (this.mode == 'default') {     // The user votes herself, so the cast agree modal needs to pop up

      if (this.isAdmin) {
        alert('You cannot vote in preview mode!');
        return;
      }

      var that = this;

      let voterId = this.userId;

      var modalInstance = this.$uibModal.open({
        animation: true,
        component: 'castVoteAgree',
        resolve: {
          config: function() {
            return {
              secret: that.ballot.secret,
              hasAttachment: !!that.ballot.attachment,
              username: that.getComposedName(that.user)
            }
          }
        },
        size: 'md'
      });

      modalInstance.result.then(
        function (password) {

          if (!that.ballot.secret) {      /* Non-Secret Vote */

            that.VotingsService.upsertNonSecretVote({id: that.voteId, voterId: voterId, propertyId: that.selectedProperty._id}, {
              ballotId: that.ballotId,
              responses: [].concat(that.selection, that.writeInSelection),
              type: "evote",
              tz: moment.tz.guess(),
              weight: that.selectedProperty.eVoting.weight || 1,
              lotNo: that.selectedProperty.lotNo,
              address: (that.selectedProperty.address && that.selectedProperty.address.street) ? that.selectedProperty.address.street : "-"
            }, onSuccess, err => {
              console.log(err);
            });

          } else {                        /* Secret Vote */

            that.secureStoring = true;

            that.VotingsService.castVote({id: that.voteId, voterId: voterId, propertyId: that.selectedProperty._id}, {
              ballotId: that.ballotId,
              responses: [].concat(that.selection, that.writeInSelection),
              type: "evote",
              tz: moment.tz.guess(),
              weight: that.selectedProperty.eVoting.weight || 1,
              password: password,
              lotNo: that.selectedProperty.lotNo,
              address: (that.selectedProperty.address && that.selectedProperty.address.street) ? that.selectedProperty.address.street : "-"
            }, onSuccess, err => {
              that.secureStoring = false;
              console.log(err);
            });

          }

        },
        function () { /* cancel */ }
      );

    } else if (this.mode == 'paper' || this.mode == 'proxy') {

      let payload = {
        ballotId: this.ballotId,
        responses: [].concat(this.selection, this.writeInSelection),
        type: "paper",
        weight: this.selectedProperty.eVoting.weight || 1,
        voteByProxy: this.mode === 'proxy'
      };

      this.secureStoring = true;

      this.VotingsService.castVote({id: this.voteId, voterId: this.userId, propertyId: this.selectedProperty._id}, payload, _ => {
        this.properties = this.properties.filter(ppty => ppty._id != this.selectedProperty._id);
        onSuccess();
      }, err => {
        that.secureStoring = false;
        console.log(err);
      });

    }

  }
}

export default angular.module('conduu.castVote', [uiRouter])
  .config(routes)
  .component('castVote', {
    template: require('./cast-vote.html'),
    controller: CastVoteComponent,
    controllerAs: 'ctrl',
    bindings: {
      mode: '@'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/cast-vote/property/cast-vote.component.js